import React from "react";
import "./InlineStatusLoader.scss";

/**
 * Reusable inline loader for section-level fetch states.
 * Styled to match pincode delivery loader with optional helper text.
 */
export function InlineStatusLoader({
  message = "Loading...",
  helperText = "",
  className = "",
}) {
  return (
    <div className={`inline-status-loader ${className}`.trim()} role="status" aria-busy="true">
      <span className="inline-status-loader__spinner" aria-hidden />
      <div className="inline-status-loader__content">
        <span className="inline-status-loader__message">{message}</span>
        {helperText ? <span className="inline-status-loader__helper">{helperText}</span> : null}
      </div>
      <span className="inline-status-loader__sr-only">{message}</span>
    </div>
  );
}

